import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  Paper,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { SetStateAction, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  StartLoading,
  StopLoading,
} from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import {
  ShowError,
  ShowSuccess,
} from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import { API_AKEY } from "../../../Services/Endpoint";
import BaseInstance from "../../../Services/AxiosInstance/BaseInstance";
import { formatDate, isOnlyAlphabetsNumbers } from "../../../Shared-ui/utils/Common/Common";
import { Inform } from "../../../Shared-ui/Types/Confirm";
import InfPopups from "../../../Shared-ui/SharedComponents/InfoPopup";
import ConfirmBase from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";
import { Embed as IEmbed } from "../../../Shared-ui/Types/common";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import { EmbedInfoText } from "../../../Constant/Setting";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Styled Button
const StyledColorButton = styled(Button)(({ theme }) => ({
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
  textTransform: "capitalize",
  fontWeight: 400,
  borderRadius: "8px",
  height: "40px",
  whiteSpace: "nowrap",
}));

interface MyComponentProps {
  agentId?: string;
  multiAgentId?: string;
  setTabId: React.Dispatch<SetStateAction<number>>;
  tabId: number;
  handleClose: () => void;
}

const CreateEmbedForm: React.FC<MyComponentProps> = (props) => {
  const [InfoPopupData, setInfoPopupData] = useState<Inform>({ show: false });
  const [embedErr, setEmbedErr] = useState({
    description: { error: "", value: false },
    agent_id: { error: "", value: false },
    expires_at: { error: "", value: false },
  });
  const dispatch = useDispatch();
  const embedInitial = {
    description: "",
    expires_at: null,

  };
  const [isEditing, setIsEditing] = useState(false);
  const [embed, setEmbed] = useState<any>({ ...embedInitial });
  const [confirmPopupData, setConfirmPopupData] = useState<ConfirmBase>({
    show: false,
  });
  const [embedings, setEmbedings] = useState<IEmbed[]>([]);
  const [dateTo, setDateTo] = useState<Date | null>(null);

  useEffect(() => {
    if (props.agentId) {
      setEmbed((preVal: any) => ({ ...preVal, agent_id: props.agentId }));
    }
    if (props.multiAgentId) {
      setEmbed((preVal: any) => ({ ...preVal, team_id: props.multiAgentId }));
    }
  }, [props.agentId, props.multiAgentId]);

  useEffect(() => {
    if (props.agentId) {
      getEmbedingAgent()
    }

  }, [props.agentId, props.tabId]);

  useEffect(() => {

    if (props.multiAgentId) {
      getEmbedingAMultigent()
    }

  }, [props.multiAgentId, props.tabId]);

  const getEmbedingAgent = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(
        `${API_AKEY}?agent_id=${props.agentId}`
      ).then((res) => res?.data?.api_keys);
      data.sort(
        (a: { created_at: string }, b: { created_at: string }) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setEmbedings(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const getEmbedingAMultigent = async () => {
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.get(
        `${API_AKEY}?team_id=${props.multiAgentId}`
      ).then((res) => res?.data?.api_keys);
      data.sort(
        (a: { created_at: string }, b: { created_at: string }) =>
          new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
      setEmbedings(data);
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const validateEmbedForm = () => {
    var error = false;

    // Reset all errors first to clear previous states
    setEmbedErr({
      description: { error: "", value: false },
      agent_id: { error: "", value: false },
      expires_at: { error: "", value: false },
    });

    const setError = (field: string, condition: boolean, message: string) => {
      if (condition) {
        setEmbedErr((prev) => ({
          ...prev,
          [field]: { error: message, value: true },
        }));
        return true;
      } else {
        setEmbedErr((prev) => ({
          ...prev,
          [field]: { error: "", value: false },
        }));
        return false;
      }
    };

    // Validate Description

    if (
      setError(
        "description",
        !embed.description.trim(),
        "Description is required."
      )
    ) {
      error = true;
    } else if (
      setError(
        "description",
        !isOnlyAlphabetsNumbers(embed.description.trim()),
        "Please enter the description A-z."
      )
    ) {
      error = true;
    }

    setError("agent_id", !embed.agent_id, "Please enter the email");

    if (setError("expires_at", !embed.expires_at, "Expiry Date is required.")) {
      error = true;
    } else {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(embed.expires_at);
      selectedDate.setHours(0, 0, 0, 0);

      if (
        setError(
          "expires_at",
          selectedDate < today,
          "Expiry date must be today or in the future."
        )
      ) {
        error = true;
      }
    }
    return !error;
  };

  const createEmbed = async () => {
    if (!validateEmbedForm()) {
      dispatch(
        ShowError("Please fill in all required fields and correct errors")
      );
      return;
    }
    try {
      dispatch(StartLoading());
      const data = await BaseInstance.post(`${API_AKEY}`, embed).then(
        (res) => res?.data
      );
      dispatch(ShowSuccess("created Api key"));
      setInfoPopupData({
        show: true,
        setInfoPopupData: setInfoPopupData,
        title: "Copy Your Key",
        info: `${EmbedInfoText}`,
        data: `${data.full_key}`,
        varient: "info",
        functionName: handleClose,
      });
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.statusText));
    } finally {
      dispatch(StopLoading());
    }
  };

  const handleClose = () => {
    setInfoPopupData((preVal) => ({ ...preVal, show: false }));
    setShowForm(false);

    if (props.agentId) {
      getEmbedingAgent()
    }

    if (props.multiAgentId) {
      getEmbedingAMultigent()
    }
  };

  const handleChangeDate = (newValue: any) => { };
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target;
    setEmbed((preVal: any) => ({ ...preVal, [name]: value }));
    if (name === "description") {
      if (value.trim() === "") {
        setEmbedErr((prev) => ({
          ...prev,
          description: { error: "Description is required.", value: true },
        }));
      } else if (!isOnlyAlphabetsNumbers(value.trim())) {
        setEmbedErr((prev) => ({
          ...prev,
          description: {
            error: "Please enter the description A-z",
            value: true,
          },
        }));
      } else {
        setEmbedErr((prev) => ({
          ...prev,
          description: { error: "", value: false },
        }));
      }
    }
  };

  const [showForm, setShowForm] = useState(false);

  const deleteEmbed = async (rowInfo: any) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading());
      const embed = rowInfo.row;
      const data = await BaseInstance.delete(`${API_AKEY}/${embed.id}`).then(
        (res) => res?.data
      );
      if (props.agentId) {
        getEmbedingAgent()
      }

      if (props.multiAgentId) {
        getEmbedingAMultigent()
      }
      dispatch(ShowSuccess("Deleted embedding"));
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail));
    } finally {
      dispatch(StopLoading());
    }
  };

  const columns: GridColDef[] = [
    { field: "description", headerName: "Description", width: 100 },
    {
      field: "created_at",
      headerName: "Created",
      headerAlign: 'center',
      width: 150,
      align: 'center',
      valueFormatter: (params: any) => {
        if (!params) return "";
        return (
          formatDate(params as string || "")
        );
      }
    },
    {
      field: "expires_at", headerName: "Expiry", width: 100, align: 'center', headerAlign: 'center', valueFormatter: (params: any) => {
        if (!params) return "";
        const date = new Date(params as string);
        return (
          formatDate(params as string || "")
        );
      }
    },
    { field: "is_active", headerName: "Status", width: 100, align: 'center', headerAlign: 'center', },
    { field: "key_prefix", headerName: "Key Prefix", width: 100, align: 'center', headerAlign: 'center', },
    {
      field: "last_used_at", headerName: "Last Used", width: 100, align: 'center', headerAlign: 'center',
      valueFormatter: (params: any) => {
        if (!params) return "";

        return (
          formatDate(params as string || "")
        );
      }
    },
  ];

  const actionColumns: GridColDef[] = [
    {
      field: "actions",
      headerName: "Actions",
      width: 100,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params) => {
        const handleDeleteClick = (event: React.MouseEvent) => {
          event.stopPropagation(); // Prevent row selection
          setConfirmPopupData({
            show: true,
            setConfirmPopupData: setConfirmPopupData,
            title: "Confirm Deletion",
            info: "Are you sure want to delete your data? This action cannot be undone.",
            varient: "delete",
            functionName: deleteEmbed,
            functionParam: params,
          });
        };

        return (
          <>
            <Box>
              <IconButton aria-label="delete" onClick={handleDeleteClick}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Box>
          </>
        );
      },
    },
  ];

  return (
    <>
      <Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 2,
          }}
        >
          <Typography variant="h6">
            API Keys
          </Typography>
          <StyledColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            onClick={() => {
              setShowForm(true);
              if (props.agentId) {
                setEmbed({ ...embedInitial, agent_id: props.agentId });
              }
              if (props.multiAgentId) {
                setEmbed({ ...embedInitial, team_id: props.multiAgentId });
              }
              setEmbedErr({
                description: { error: "", value: false },
                agent_id: { error: "", value: false },
                expires_at: { error: "", value: false },
              });
            }}
          >
            Create API Key
          </StyledColorButton>
        </Box>
        {showForm && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              mt: 3,
            }}
          >
            <FormControl fullWidth variant="outlined" required>
              <InputLabel
                htmlFor="agent_id"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Assistant Id
              </InputLabel>
              <TextField
                //size="small"
                id="agent_id"
                name="agent_id"
                value={embed.agent_id ? embed.agent_id : embed.team_id ? embed.team_id : ""}
                disabled={true}
                sx={{ background: "white" }}
              />
            </FormControl>

            <FormControl fullWidth variant="outlined" required>
              <InputLabel
                htmlFor="description"
                shrink
                sx={{ background: "#fff", px: 0.5 }}
              >
                Description
              </InputLabel>
              <TextField
                id="description"
                name="description"
                placeholder="Enter the remarks"
                multiline
                rows={4}
                inputProps={{ maxLength: 500 }}
                value={embed.description}
                onChange={(e) => handleChange(e)}
                sx={{ background: "white" }}
                error={embedErr.description.value}
                helperText={
                  embedErr.description.value ? embedErr.description.error : ""
                }
              />
              <Box display="flex" justifyContent="flex-end">
                <Typography
                  variant="caption"
                  color="textSecondary"
                  align="right"
                >
                  {`${embed.description.length} / ${500} characters`}
                </Typography>
              </Box>
            </FormControl>

            <FormControl fullWidth variant="outlined" required>
              <InputLabel
                shrink
                htmlFor="dateTo"
                sx={{ background: "#fff", px: 0.5 }}
              >
                Expiry Date
              </InputLabel>
              <DatePicker
                selected={embed.expires_at ? new Date(embed.expires_at) : null}
                onChange={(date) => {
                  if (date) {
                    const utcDate = new Date(
                      Date.UTC(
                        date.getFullYear(),
                        date.getMonth(),
                        date.getDate()
                      )
                    );
                    const today = new Date();
                    today.setUTCHours(0, 0, 0, 0);

                    if (utcDate > today) {
                      setDateTo(date);
                      setEmbed((preVal: typeof embed) => ({
                        ...preVal,
                        expires_at: utcDate,
                      }));
                      setEmbedErr((prev) => ({
                        ...prev,
                        expires_at: { error: "", value: false },
                      }));
                    } else {
                      dispatch(
                        ShowError("Expiry date must be greater than today.")
                      );
                      setEmbedErr((prev) => ({
                        ...prev,
                        expires_at: {
                          error: "Expiry date must be today or in the future.",
                          value: true,
                        },
                      }));
                      setEmbed((preVal: typeof embed) => ({
                        ...preVal,
                        expires_at: null,
                      }));
                    }
                  }
                }}
                placeholderText="dd/mm/yyyy"
                dateFormat="dd/MM/yyyy"
                customInput={
                  <TextField
                    fullWidth
                    variant="outlined"
                    inputProps={{ maxLength: 50 }}
                    error={embedErr.expires_at.value}
                    helperText={
                      embedErr.expires_at.value ? embedErr.expires_at.error : ""
                    }
                  />
                }
              />
            </FormControl>

            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: 2,
                justifyContent: "flex-end",
              }}
            >
              <Button
                // fullWidth
                variant="outlined"
                disableElevation
                size="large"
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => handleClose()}
              >
                Cancel
              </Button>
              <Button
                // fullWidth
                variant="contained"
                disableElevation
                size="large"
                sx={{
                  textTransform: "capitalize",
                }}
                onClick={() => createEmbed()}
              >
                {isEditing ? "Update" : "Create"}
              </Button>
            </Box>
          </Box>
        )}
        <Paper sx={{ height: 300, width: "100%", my: "20px" }} elevation={0}>
          <DataGrid
            pagination
            rows={embedings}
            columns={[...columns, ...actionColumns]}
            pageSizeOptions={[5, 10]}
            paginationMode="client"
            initialState={{
              pagination: { paginationModel: { pageSize: 5, page: 0 } },
            }}
            sx={{
              border: 1,
              borderColor: "#eee",
              "& .MuiDataGrid-cell:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus-within": {
                outline: "none",
              },
            }}
          />
        </Paper>
      </Box>

      <InfPopups details={InfoPopupData} />
      <ConfirmPopup details={confirmPopupData} />
    </>
  );
};

export default CreateEmbedForm;
